<div fxLayout="column">
  <mat-card [style.background-color]="uiData.atp.color">
      <mat-card-title>
          {{'Edit ATP Staff'}}
      </mat-card-title>
  </mat-card>
  <div class="scroll-container">   
    <mat-form-field style="width: 100%;">
      <mat-label>Staff</mat-label>
      <input matInput [value]="displayStaffMember(selectedPerson)" [disabled]="true">        
    </mat-form-field>

    <div fxLayout="column">
      <mat-checkbox [(ngModel)]="isContact">
        <span class="mat-checkbox-label">
            Is Contact
        </span>
      </mat-checkbox> 
      <mat-checkbox [(ngModel)]="isInstructor">
        <span class="mat-checkbox-label">
            Is Instructor
        </span>
      </mat-checkbox> 
      <mat-checkbox [(ngModel)]="isPrimaryInstructor">
        <span class="mat-checkbox-label">
            Is Primary Instructor
        </span>
      </mat-checkbox> 
      <mat-checkbox [(ngModel)]="isTrainingManager">
        <span class="mat-checkbox-label">
            Is Training Manager
        </span>
      </mat-checkbox> 
    </div>     
  </div>
  <mat-card [style.background-color]="uiData.atp.color" fxLayout="row wrap" fxLayoutGap="8px">
    <button mat-raised-button color="primary" [disabled]="!selectedPerson" (click)="onSubmit()">{{'Update'}}</button>
    <button mat-raised-button (click)="onCancel()">Cancel</button>
  </mat-card> 
</div>
